import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tax-category-display',
  templateUrl: './tax-category-display.component.html',
  styleUrls: ['./tax-category-display.component.scss']
})
export class TaxCategoryDisplayComponent implements OnInit {

  constructor() { }

  @Input() category: 0|1|2|3 ;

  ngOnInit(): void { }
}
